if(BSS_B2B && typeof BSS_B2B === 'object'){
  setTimeout(() => {
    const element = document.querySelector(".product__info-container.product__column-sticky");
    if(element){
      const observer = new MutationObserver((MutationList) => {
        for(let item of MutationList){
          if(item.target.className.includes('product__info-container') && item.addedNodes[0].localName === 'variant-selects'){
            setTimeout(() => {
              console.log(123);
              BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false)
              BSS_B2B.qi.handleSetupQuantity();
            },1000)
          }
        }
      })
      observer.observe(element, {childList: true, subtree: true})
    }
  }, 300)
}